import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Form, InputForm, Validation } from "../../components/Form";
import { Autocomplete } from "../../components/Autocomplete";
import { BasePaper, Row } from "../../components/Base";
import Button from "../../components/Button";
import { getpassCondition, createPassCondition, updatePassCondition } from "../../api/passConditions";
import useUser from "../../hooks/useUser";
import passConditionCourseTypesList from "../../services/typePassConditionCourseList.json";

import moduleTrainingOptions from "../../services/moduleTraining.json";
import roleTrainingList from "../../services/roleTrainingList.json";

const EditPassConditions = ({ match, history }) => {
  const { t } = useTranslation();
  const user = useUser();
  const { passConditionId } = match.params;
  const isAdd = !passConditionId;
  const [passCondition, setpassCondition] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [selectedModuleTraining, setModuleTraining] = useState(moduleTrainingOptions[0]);
  const [selectedPassConditionCourseTypes, setPassConditionCourseTypes] = useState(passConditionCourseTypesList[0]);
  const [selectedRoleTraining, setRoleTraining] = useState(roleTrainingList[0]);

  useEffect(() => {
    (async () => {
      if (passConditionId) {
        const passConditionRes = await getpassCondition(passConditionId);
        setpassCondition(passConditionRes);

        const rolePassCondition = roleTrainingList.find((c) => c.code === passConditionRes.role);
        setRoleTraining(rolePassCondition);
        const modulePassCondition = moduleTrainingOptions.find((c) => c.code === passConditionRes.module);
        setModuleTraining(modulePassCondition);
        const itemPassCondition = passConditionCourseTypesList.find((c) => c.code === passConditionRes.type);
        setPassConditionCourseTypes(itemPassCondition);
      }
      setLoaded(true);
    })();
  }, [passConditionId]);

  const goBack = () => history.goBack();

  const onSubmit = async (values) => {
    values.module = selectedModuleTraining.code;
    values.role = selectedRoleTraining.code;
    values.type = selectedPassConditionCourseTypes.code;
    if (values.type == "yes-no") {
      values.value = null;
    }
    let result;
    if (isAdd) {
      result = await createPassCondition(values);
    } else {
      result = await updatePassCondition(passConditionId, values);
    }
    if (result.ok) {
      history.push("/pass-conditions");
    }
  };

  const title = isAdd ? t("pass_condition.add_title") : t("pass_condition.edit_title");

  return (
    <>
      <Typography variant="h4">
        <Button icon={<ArrowBackIcon />} onClick={goBack} />
        {title}
      </Typography>
      {loaded ? (
        <BasePaper>
          <Form
            defaultValues={{
              name: passCondition?.name,
              description: passCondition?.description,
              role: passCondition?.role,
              module: passCondition?.module,
              type: passCondition?.type,
              value: passCondition?.value,
            }}
            validation={{
              name: Validation.required,
            }}
            onSubmit={onSubmit}
          >
            <Row>
              <InputForm name="name" label={t("pass_condition.name_required")} />
            </Row>

            <Row>
              <InputForm name="description" label={t("pass_condition.description")} />
            </Row>

            <Row>
              <Autocomplete
                label={t("training_pages.evaluator")}
                options={roleTrainingList}
                value={selectedRoleTraining}
                onChange={(items) => {
                  setRoleTraining(items);
                }}
                getOptionLabel={(item) => `${item.name}`}
              />
            </Row>

            <Row>
              <Autocomplete
                label={t("pass_condition.module_training")}
                options={moduleTrainingOptions}
                value={selectedModuleTraining}
                onChange={(items) => {
                  setModuleTraining(items);
                }}
                getOptionLabel={(item) => `${item.name}`}
              />
            </Row>

            <Row>
              <Autocomplete
                label={t("pass_condition.type")}
                options={passConditionCourseTypesList}
                value={selectedPassConditionCourseTypes}
                onChange={(items) => {
                  setPassConditionCourseTypes(items);
                }}
                getOptionLabel={(item) => `${item.name}`}
              />
            </Row>
            {selectedPassConditionCourseTypes.code != "yes-no" && (
              //selectedPassConditionCourseTypes
              <Row>
                <InputForm name="value" label={t("pass_condition.value")} />
              </Row>
            )}

            <Row>
              <Button type="submit">{t("save")}</Button>
              <Button onClick={goBack}>{t("cancel")}</Button>
            </Row>
          </Form>
        </BasePaper>
      ) : null}
    </>
  );
};

export default EditPassConditions;
